//#region src/environment.ts
/**
* When adding new values here, please remember to update any of the methods/types below as well as:
* - packages/bureau/bite.json
* - packages/maitred/src/script/deploy.ts
* - packages/maitred/src/script/set_env_vars.ts
* - packages/node-service/src/middleware/session_setup.js
* OR anywhere else where we use process.env.APP_ENV
* OR anywhere Environment.STAGING is mentioned
* OR anywhere that uses a type Environment[]
*/
var Environment = /* @__PURE__ */ function(Environment) {
	Environment["DEV"] = "dev";
	Environment["PROD"] = "prod";
	Environment["STAGING"] = "staging";
	Environment["SANDBOX"] = "sandbox";
	Environment["TEST"] = "test";
	return Environment;
}(Environment || {});
//#endregion
export { Environment };

//# sourceMappingURL=environment.js.map